import { useState } from "react";
import { useDispatch } from "react-redux";

import { bulkRemoveCompanyEventRequestsRequest } from "../../../../../../store/CompanyPortal/EventRequests/actions";

const useEditRemovalReason = ({
  rows,
  selectedIds,
  listParams,
  setSelectedIds,
  onRefreshEvent,
}) => {
  const dispatch = useDispatch();
  const [editReasonTargetIds, setEditReasonTargetIds] = useState([]);
  const editReasonApplicants = rows.filter((row) =>
    editReasonTargetIds.includes(row.id),
  );

  const openEditReasonModal = () => {
    setEditReasonTargetIds(selectedIds);
  };

  const closeEditReasonModal = () => {
    setEditReasonTargetIds([]);
  };

  const confirmEditReason = ({ reason }) => {
    dispatch(
      bulkRemoveCompanyEventRequestsRequest({
        eventRequestIds: editReasonTargetIds,
        removalReason: reason,
        listParams,
        onSuccess: () => {
          setSelectedIds([]);
          setEditReasonTargetIds([]);
          onRefreshEvent?.({ silent: true });
        },
      }),
    );
  };

  return {
    editReasonApplicants,
    isEditReasonModalOpen: editReasonTargetIds.length > 0,
    openEditReasonModal,
    closeEditReasonModal,
    confirmEditReason,
  };
};

export default useEditRemovalReason;
